/** Pedidos já cancelados que saíram da meta, do faturamento e da MC (21/10/2026). Status do pedido em `pedidos` (S1);
 * não pago e em cancelamento seguem contando. Valor e MC são do pedido inteiro (margem oficial). */
import { useState } from 'react'
import { Box, Button, Link, Typography } from '@mui/material'
import { TabelaOrdenavel } from './componentes'
import { brl, brl2, dataBr, nomeLoja, num } from './logic'
import type { NatalData, PedidoCancelado } from './types'

const CANAL: Record<string, string> = { mercadolibre: 'ML', shopee: 'Shopee', tiktok: 'TikTok', shein: 'Shein', amazon: 'Amazon' }

export function Cancelados({ d }: { d: NatalData }) {
  const [aberto, setAberto] = useState(false)
  const c = d.cancelados
  if (!c || !c.pedidos) return null
  const link = (x: PedidoCancelado) => d.anuncios.find((a) => a.loja === x.loja && (a.item_id ?? a.id) === x.anuncio)?.link ?? null
  const canais = Object.entries(c.por_canal).sort((a, b) => b[1].pedidos - a[1].pedidos).map(([k, v]) => `${CANAL[k] ?? k} ${v.pedidos}`).join(' · ')
  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="caption" color="text.secondary" component="div"
        title="Pedidos já cancelados (por você ou pelo cliente) não contam na meta, no faturamento nem na MC. Não pago e em cancelamento seguem contando até mudar de status.">
        Fora da meta: <b>{num(c.pedidos)} pedido(s) cancelado(s)</b> · {brl(c.valor)} ({canais})
        <Button size="small" sx={{ ml: 1, py: 0, minWidth: 0 }} onClick={() => setAberto((v) => !v)}>{aberto ? 'ocultar' : 'ver pedidos'}</Button>
      </Typography>
      {aberto && (
        <TabelaOrdenavel vazio="—" alturaMax="40vh" linhas={c.lista} colunas={[
          { label: 'Dia', valor: (x) => x.dia, render: (x) => dataBr(x.dia) },
          { label: 'Loja', valor: (x) => x.loja, render: (x) => nomeLoja(d, x.loja) },
          { label: 'Pedido', valor: (x) => x.pedido, render: (x) => x.pedido },
          { label: 'SKU', valor: (x) => x.skus.join(', '), render: (x) => x.skus.join(', ') },
          { label: 'Anúncio', valor: (x) => x.titulo, render: (x) => {
            const l = link(x)
            return l ? <Link href={l} target="_blank" rel="noopener noreferrer">{x.titulo || x.anuncio}</Link> : (x.titulo || x.anuncio || '—')
          } },
          { label: 'Qtd', valor: (x) => x.qtd, render: (x) => num(x.qtd), alinhar: 'right' },
          { label: 'Valor do pedido', valor: (x) => x.valor, render: (x) => brl2(x.valor), alinhar: 'right' },
          { label: 'MC', valor: (x) => x.mc, render: (x) => brl2(x.mc), alinhar: 'right' },
          { label: 'Status', valor: (x) => x.status, render: (x) => x.status },
        ]} />
      )}
    </Box>
  )
}
